<template>
    <div class="rivacypolicy">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <div class="agreement">
                    <h1 class="page-title">《壹米滴答服务条款》</h1>
                    <div class="title_level_1">1、缔约主体与接受声明</div>
                    <div>本条款的缔约主体是您与上海壹米滴答快运有限公司或其子公司、分公司或关联公司（以下简称"壹米滴答"、"本公司"）。请您认真阅读本条款，您使用壹米滴答服务表明您已充分阅读、理解并接受本条款的全部内容，并确认您因工作需要使用本服务时，您已充分获得您工作单位的授权。</div>

                    <div class="title_level_1">2、快件送达与签收认定</div>
                    <div>您确认，壹米滴答将快件送达收件人地址，经收件人或收件人（寄件人）允许的代收人签收，视为送达。若无收件人姓名，仅有收件地址，则由收件地址收件人员签收，或盖单位收发章，视为送达。您或您的委托人对快件进行签收即表明您确认壹米滴答已经按照本《服务条款》履行完毕合同义务。</div>

                    <div class="title_level_1">3、争议解决方式</div>
                    <div>本条款履行过程中如发生争议，双方应友好协商解决。如协商不成的，应向寄件地有管辖权的人民法院提起诉讼。</div>

                    <div class="title_level_1">4、隐私政策遵守</div>
                    <div>您同意遵守壹米滴答官方网站、公众号、小程序和APP等所公示的隐私政策及其不时修订的内容，同意壹米滴答按照法律法规和隐私政策的规定处理您提供的运单信息。</div>

                    <div class="title_level_1">5、保价与赔偿规则</div>
                    <div>5.1 因本公司原因造成托寄物毁损、灭失的，结合您是否保价对应的标准进行赔偿，该赔偿不包括您基于货物可能获得的收益、利润、实际用途、商业机会、商业价值等任何间接损失。</div>
                    <div>5.2 若快件尚未支付所有运输费用，壹米滴答无义务受理赔偿。</div>
                    <div>5.3 壹米滴答对托寄物价值采取"理赔审查"的方式，包括：1）您应在寄件时如实按照托寄物的实际价值诚信保价；2）您应在理赔时提供托寄物的真实有效价值证明（如发票，合同、付款凭证组合）和按壹米滴答要求提供相关资料（如可见运单号的外包装、内包装和托寄物损坏图片，损坏物品放在快递运单旁边拍照等）并主动说明损失快件情况。壹米滴答会结合市场价值和第三方机构意见评估损失价值并按保价金额结合损失的比例进行赔偿。如您无法证明托寄物品的实际价值，壹米滴答将全额退还您的保价费用，按照未保价快件进行赔偿。</div>
                    <div>5.4 每票快件只能提出一次索赔，且与该快件相关的所有损失或损坏的赔偿是完全并最终的。如寄件人认为本条款和条件关于赔偿的规定将不足以补偿其损失，则应购买保价。</div>
                    <div>5.4.1 若您未选择保价 1）在运输环节发生灭失、破损、短少的，壹米滴答在 5倍运费限额内向您赔偿托寄物的实际损失，同时赔偿额最高不超过托寄物的实际价值。2）如您认为该赔偿标准不足以弥补您的损失，应根据托寄物的实际价值进行保价。如您未保价，视为托寄物价值不超过1000 元。</div>
                    <div>5.4.2 若您已选择保价且支付保价费用 1）壹米滴答提供的保价服务，系基于您的保价金额收取费用，并基于保价金额、托寄物实际价值、受损货物价值等因素综合考虑赔偿，请您如实按照托寄物实际价值进行保价。2）壹米滴答对部分价值不易核实、易破损等物品不提供保价服务。</div>
                    <div>因壹米滴答原因导致保价快件在运输环节发生损坏的，对于可以维修的托寄物，壹米滴答在保价金额的限额内赔偿维修费用。经壹米滴答认可的鉴定评估机构认定托寄物全损，或维修费用高于托寄物实际价值的，壹米滴答按照快件灭失进行赔偿，但最高不超过保价金额。</div>
                    <div>因壹米滴答原因导致保价快件在运输环节发生全部灭失的，壹米滴答按照实际损失向您赔偿，但最高不超过保价金额。</div>
                    <div>因壹米滴答原因导致保价快件在运输环节发生部分灭失的，壹米滴答以如下标准向您赔偿：赔偿金额=保价金额/货物全部实际价值*受损货物价值，如保价金额大于货物全部实际价值，则按照受损货物价值确定赔偿金额。您或指定付款人拒绝支付保价费用的，壹米滴答将按照未保价快件进行赔偿。</div>
                    <div>5.4.4 托寄物损坏残值由壹米滴答和您协商处理，如归您所有，壹米滴答在核定赔偿金额时将扣减残值。</div>
                    <div>5.4.5 您选择签单返还服务时，若因壹米滴答原因导致签收回单破损、灭失的，壹米滴答承担的责任仅限于免费提供一次签单返还服务作为赔偿。</div>
                    <div>5.4.6 因壹米滴答与保险公司针对托寄物存在合作投保的情况，如托寄物出现损坏、遗失等异常状况时，可能由该等保险公司直接负责相关的理赔事宜。为保障您的个人权益，您的寄件信息、托寄物信息等个人信息将会同步至与壹米滴答合作的保险公司，并由该等保险公司处理您的托寄物理赔事宜。如您签订本协议，即视为同意壹米滴答将您的上述个人信息同步至与壹米滴答合作的保险公司并同意由该等保险公司用于处理托寄物理赔事宜。</div>
                    <div>5.5 特别提醒您注意，发生以下情形之一的壹米滴答无赔偿责任：1）因不可抗力或疫情等政府管控行为、决定或命令导致快件灭失、破损、短少、延误的。2）因您寄递的物品违反禁寄或限寄规定，被国家行政机关没收或依照有关法律法规处理的。3）因您或收件人过失以及托寄物物品自身原因（包括但不限于托寄物自身属性、内在缺陷或合理损耗及与运单信息填写错误或不全等）造成快件损失或延误的。4）外包装完好，而内件短少或毁损，签收人签收时未提出异议的（包括但不限于壹米滴答无法拆开托寄物原包装进行内包装加固且派件时原包装无明显异常，或您自备的托寄物包装不良但外部无法发现等场景）。5）生鲜、冷冻类物品，签收后超 48 小时反馈的。6）代收货款件，因收寄双方发生买卖纠纷导致收件人对托寄物采取保全措施（如扣留托寄物）而造成的损失等。7）如您与壹米滴答签订协议另有约定或有其他法律规定的，以相关约定/规定的为准。8）当托寄物为医学检测类物品时（如血液、唾液、人体组织液、尿液、粪便等），您承诺该医学检测类物品不会被用于非法途径（如：胎儿性别鉴定等）。由于医学检测类托寄物本身不属于用于销售的产品，没有销售价值。故医学检测类托寄物发生损坏、丢失，壹米滴答在5倍运费限额内向您赔偿托寄物的实际损失，双方另有约定的除外。</div>
                    <div>5.6 快件延误的赔偿仅为免除当次运费（不含保价费等附加费用）。</div>
                    <div>5.7 理赔申报时间及反馈渠道：快件如有发生损坏或遗失，应当在快件签收后 48 小时内通过壹米滴答相关渠道（包括但不限于壹米滴答客户服务中心、壹米滴答微信公众号等）反馈索赔诉求。</div>
                    <div>5.8 特殊场景下的应对方式：您确认，因不可抗力或政府管控行为、决定或命令（包括但不限于疫情原因）导致易腐损物品（如生鲜食品、时令水果、鲜花等）出现下列场景时，应当按下述约定进行操作应对：（1）因上述原因导致快件无法继续中转的，双方将积极沟通，为避免扩大损失，壹米滴答有权结合实际情况决定安排退回。（2）因上述原因导致快件停滞时间超 14个工作日 仍无法发运的，壹米滴答有权结合实际情况对快件按作废处理。</div>

                    <div class="title_level_1">6、寄件人义务</div>
                    <div>6.1 确保托寄物不包含国家机关公文、国家保护野生动物和濒危野生动物及其制品、假冒伪劣和侵权物品等法律法规禁止和限制寄递的物品 ，不得通过寄递渠道危害国家安全、公共安全和公民、法人、其他组织的合法权益。</div>
                    <div>6.2 出示有效身份证件，配合壹米滴答工作人员进行身份查验、身份信息登记，如果您是受他人委托寄件，还应当提供委托人的有效身份证件。</div>
                    <div>6.3 配合进行开箱验视，托寄物需要办理审批、检验等手续的，您应提交办理完相关手续的证明文件。壹米滴答可以对托寄物内件拍照取证，如发现禁止或限制寄递的物品，有权移交相关部门处理。</div>
                    <div>6.4 如实申报托寄物的名称、性质、数量和价值，并准确填写寄件人、收件人的名称、地址、联系电话等信息。</div>
                    <div>6.5 根据托寄物的性质（尤其是易损易碎、易腐蚀、易泄漏的液体或其他），您应根据托寄物的性质提供充分的防破损、防漏、防爆措施，保障安全运输。</div>
                    <div>6.6 参照国家邮政局安全监督管理司下发的《关于加强疫情防控监督检查强化重点工作任务落实的通知》的要求，您确认并知悉在下单前应严格履行如下要求：1）如您的托寄物品来自境外，您必须向壹米滴答履行 100%主动告知义务、100%落实实名寄递、100%如实申报托寄物；2）在托寄前，请您做好物品消杀并静置不少于 7 天（自进口货品入境时间起算），保留相关证明并根据需要履行证明义务（包括但不限于基于政府部门要求或壹米滴答管理要求而需要）。</div>

                    <div class="title_level_1">7、壹米滴答义务</div>
                    <div>7.1 出于安全及法律法规的要求，壹米滴答有权对快件进行当场开箱验视及安全监测。免生疑问，壹米滴答不会对因上述检查而导致的任何延误造成的损失负责。对禁寄及拒绝验视的快件不予收寄。</div>
                    <div>7.2 壹米滴答向寄件人提供自交寄之日起一年内的查询服务。</div>

                    <div class="title_level_1">8、加密运单与信息保存</div>
                    <div>壹米滴答为保护您的个人信息，可能会使用加密运单。壹米滴答会对您寄件时在下单系统录入的信息予以保存。对于保密运单所隐匿的信息，您同意以壹米滴答系统所查询的内容为准。</div>

                    <div class="title_level_1">9、寄件人违约赔偿责任</div>
                    <div>9.1 因托寄物有安全隐患、质量缺陷或包装破损，致使其他托寄物、运输工具、机械设备被污染腐蚀、损坏，或造成人身伤亡的，您应承担赔偿责任。</div>
                    <div>9.2 因托寄物属于或含有禁止或限制寄递物品而被查没、扣留或变更配送路线，导致其他托寄物时效延误或价值丧失，给壹米滴答或第三人造成经济损失的，您应承担赔偿责任。</div>
                    <div>9.3 因您违反第 7 条的义务导致壹米滴答或第三人承担行政处罚、民事赔偿等所造成的各项经济损失，您应承担赔偿责任。</div>

                    <div class="title_level_1">10、留置权约定</div>
                    <div>10.1 您或您指定的付款人未付清费用的，壹米滴答有权留置托寄物，留置后您的债务履行期限为 2 个月（自揽收快件之日起计算），但托寄物性质不能留置的除外。债务履行期限届满，您或指定付款人仍未付清费用的，壹米滴答可以变卖、拍卖留置物并优先受偿。变卖、拍卖所得价款应优先支付壹米滴答为行使留置权所支出的费用和保管费，再偿付拖欠壹米滴答的费用；如有余额，可根据您的要求汇至您指定账户。</div>

                    <div class="title_level_1">11、费用相关约定</div>
                    <div>1）您指示在物流中心、展馆、保税区等需要支付出/入仓费或其他额外费用的特殊地址收取或派送快件时，您或您指定付款人应当偿还壹米滴答垫付的上述出/入仓费等额外费用，并支付附加服务费，该等费用金额以壹米滴答取得的收费凭证为准。2）春节等法定节假日和"6.18""双十一"、"双十二"等业务高峰期间您需要提供服务的，可能会加收附加服务费，该等费用以壹米滴答官网、公众号等平台公示为准，您可以登陆壹米滴答官方网站或拨打壹米滴答客服热线咨询。若您在价格变更后继续寄件，表示您同意按照变更后的价格支付费用。3）若您或您指定的收件人要求变更托寄物相关信息的，壹米滴答有权要求收取额外服务费。4）若您要求退回，则双程费用均由您承担；若您对快件声明放弃的，您不可就该快件再向壹米滴答主张任何权利，您同意壹米滴答有权自行处置该快件，壹米滴答不对此承担任何责任。</div>

                    <div class="title_level_1">12、代收货款约定</div>
                    <div>1）您委托壹米滴答代收货款的金额不代表该票寄托物的实际价值，若因壹米滴答原因造成托寄物毁损、灭失的，壹米滴答按照第5条的约定予以赔偿。2）因非壹米滴答的原因造成您无法收到代收货款的，壹米滴答不承担追回代收货款无法追回的责任。</div>

                    <div class="title_level_1">13、服务时效说明</div>
                    <div>壹米滴答服务产品的时效说明以官方网站上所公示的解释为准，您可以登录官方网站查询或拨打壹米滴答客服热线咨询。</div>

                    <div class="title_level_1">14、商业信息推送与退订</div>
                    <div>壹米滴答会以电话、电子邮件、手机短信等方式告知、发送的产品/业务介绍、推广促销信息及其他商业性信息。您不同意继续接收以上信息的，可以通过短信或拨打壹米滴答客服热线方式退订。</div>

                    <div class="title_level_1">15、条款效力与补充依据</div>
                    <div>如果本条款中的某条款被法院或政府机构认定为无效或部分无效，则双方同意除无效条款外仍应执行本合同其它条款，部分有效条款在其可执行的范围内仍继续执行。本条款中未涉及事宜，按照中华人民共和国相关法律、法规及标准执行。</div>
                    <div style="height: 20px;"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { queryPrivacyPolicy } from "@/api/homePage";
export default {
    components: {},
    data() {
        return {
            conenttext: ""
        };
    },
    computed: {},
    mounted() {},
    watch: {},
    created() {
        // this.query();
    },
    methods: {
        /*query() {
            queryPrivacyPolicy()
                .then(res => {
                    if (res.status === 2000) {
                        this.conenttext = res.data.osArticleContent.content;
                    }
                })
                .catch(err => {});
        }*/
    }
};
</script>

<style scoped lang="scss">
.rivacypolicy {
    padding-bottom: 50px;
    background-color: #fff;
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        ::v-deep .el-breadcrumb {
            line-height: 50px;
            .el-breadcrumb__item {
                line-height: 46px;
            }
            .el-breadcrumb__inner {
                font-weight: bold;
                color: #ffffff;
            }
        }
    }
    .agreement {
        padding: 20px;
        height: 100%;
        font-size: 14px;
        line-height: 1.8;
        .page-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 30px 0;
            padding: 20px 0;
            border-bottom: 2px solid #e0e0e0;
            width: 100%;
        }
        div {
            text-indent: 1em;
            margin-bottom: 10px;
            color: #333;
        }
        .title_level_1 {
            text-indent: 0 !important;
            font-size: 18px;
            line-height: 40px;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 10px;
        }
        .text_link {
            color: #FFAF00;
            font-weight: bold;
            cursor: pointer;
            text-decoration: underline;
            &:hover {
                color: #ff9500;
            }
        }
    }
}
</style>
